// prettier-ignore
import { Icon } from "@fluentui/react";
import React from "react";
import styles from "./EditableItem.module.scss";

interface EditableItemProps {
  isEditing: boolean;
  onStartEdit: () => void;
  editContent: React.ReactNode;
  viewContent: React.ReactNode;
}

const EditableItem = ({isEditing, onStartEdit, editContent, viewContent}: EditableItemProps): JSX.Element => {
  return (
    <>
      {isEditing ? (
        <>
          {editContent}
          <Icon className={styles.editIcon} iconName="Edit" />
        </>
      ) : (
        <div onClick={onStartEdit}>
          {viewContent}
          <Icon className={styles.editIcon} iconName="Edit" />
        </div>
      )}
    </>
  );
};

export default EditableItem;
